import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('ActivateUserApp => ');

const bootstrap = createAction('bootstrap form values', (userId, userEmail, isSupportUser) => ({
  userId,
  userEmail,
  isSupportUser,
}));
const updateField = createAction('update form values', (fieldId, value) => ({ fieldId, value }));

const onActivateUserRequest = createAction('activate user request', (formRef, isValid) => ({ formRef, isValid }));
const onActivateUserSuccess = createAction('activate user success');
const onActivateUserFailure = createAction('activate user failure');

export default {
  bootstrap,
  updateField,

  onActivateUserRequest,
  onActivateUserSuccess,
  onActivateUserFailure,
};
